import { useRouter } from 'next/navigation';
import { Button } from '@/features/button';
export default function RetryErrorButton() {
  const router = useRouter();
  const handleRefresh = () => {
    router.refresh();
  };
  return <Button graphicStyle='outlined' size='large' className='w-full' onClick={handleRefresh} data-sentry-element="Button" data-sentry-component="RetryErrorButton" data-sentry-source-file="retry-error-button.tsx">
            تلاش مجدد
        </Button>;
}